/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";

export default function Photos() {
    const [SelectedImages, SetSelectedImages] = useState([]);
    const [ShowSelectedImages, SetShowSelectedImages] = useState([]);
  
  
    function OnImageChange(e) {
      console.log(e.target.files);
      // SetSelectedImages([...SelectedImages, ...e.target.files]);
  
      const files = e.target.files;
      const newImages = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
  
        reader.onload = (e) => {
          newImages.push(e.target.result);
          // If all files have been processed, update state
          if (newImages.length === files.length) {
            // SetSelectedImages([...SelectedImages, ...newImages]);
            SetSelectedImages(newImages);
          }
        };
        reader.readAsDataURL(files[i]);
      }
    }
    console.log(SelectedImages);
  
    function AddMoreImages(e) {
      console.log(e.target.files);
      // SetSelectedImages([...SelectedImages, ...e.target.files]);
  
      const files = e.target.files;
      const newImages = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
  
        reader.onload = (e) => {
          newImages.push(e.target.result);
          // If all files have been processed, update state
          if (newImages.length === files.length) {
            SetSelectedImages([...SelectedImages, ...newImages]);
          }
        };
        reader.readAsDataURL(files[i]);
      }
    }
  
    function removeImage(i){
      console.log(i)
      const updatedImages = [...SelectedImages];
      updatedImages.splice(i, 1); 
      SetSelectedImages(updatedImages); 
    }
  return (
    <>
      {SelectedImages.length < 1 && (
        <div
          className="tab-pane fade active show"
          id="pills-tab1"
          role="tabpanel"
          aria-labelledby="pills-Tab1-tab"
        >
          <div className="row mt-20 ml-10">
            <div className="col-xl-12 col-lg-12 col-md-12 ">
              <h6 className=" heading">Photos</h6>
              <p className="sub-heading">my photos ({SelectedImages.length})</p>
            </div>
          </div>
          <div className="content-section">
            <div className="row mt-20 ">
              <div className="col-xl-12 col-lg-12 col-md-12 ">
                <div className="text-sub">
                  Let’s get started by adding your photos!
                </div>
                <div className="dark-sub mt-10">
                  Drag and drop or click in the boxes below.
                </div>
              </div>
              <div className="image-section mt-20 d-flex">
                <div className="col-xl-12 col-lg-12 col-md-12 text-center m-auto">
                  <div className="text-sub">
                    <label for="file-input">
                      <img
                        src="assets/img/breadcrumb/add-from-computer.png"
                        alt=""
                        style={{ cursor: "pointer" }}
                      />
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      // multiple
                      style={{ display: "none" }}
                      onChange={OnImageChange}
                    />
                  </div>
                </div>
                {/*  <div class="col-xl-6 col-lg-6 col-md-12 ">
                                                   <div class="dark-sub">
                                                       <img src="assets/img/breadcrumb/add-from-form.png" alt=""="">
                                                   </div>
                                                   </div> */}
              </div>
            </div>
            <div className="row mt-20  lower-btn">
              <div className="col-xl-12 col-lg-12 col-md-12 ">
                <h6 className=" heading-connect mb-20">
                  Or connect to other services to import:
                </h6>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 m-auto text-center">
                <a className="tp-btn-lg large head mb-10" href="#">
                  <span>
                    <i className="fa-brands fa-facebook-f" />
                  </span>
                  Facebook
                </a>
                <a className="tp-btn-lg large head mt-10" href="#">
                  <span>
                    <i className="fa-brands fa-apple" />
                  </span>
                  Instagram
                </a>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 m-auto text-center ">
                <a className="tp-btn-lg large head mb-10" href="#">
                  <span>
                    <i className="fa-brands fa-apple" />
                  </span>
                  Apple iCloud
                </a>
                <a className="tp-btn-lg large head mt-10" href="#">
                  <span>
                    <i className="fa-brands fa-skype" />
                  </span>
                  Snapchat
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {SelectedImages.length >= 1 && (
        <div
          className="tab-pane fade active show"
          id="pills-tab1"
          role="tabpanel"
          aria-labelledby="pills-Tab1-tab"
        >
          <div className="row mt-20">
            <div className="col-xl-12 col-lg-12 col-md-12 ">
              <h6 className=" heading">Photos</h6>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12 ">
              <label for="file-input1" style={{ width: "100%", height: 60 }}>
                <a
                  className="tp-btn-lg large head price two"
                  style={{ width: "100%", height: 60, cursor: "pointer" }}
                >
                  Add More Photos
                </a>
              </label>
              <input
                id="file-input1"
                type="file"
                // multiple
                style={{ display: "none" }}
                onChange={AddMoreImages}
              />
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12 mt-20">
              <div className="multi-p-select mb-3">
                <div className="photo-left">
                  <p className="sub-heading mb-0">
                    my photos ({SelectedImages.length})
                  </p>
                </div>
                <div className="photo-right">
                  <input
                    type="sq-radio"
                    aria-label="sq-radio button for following text input"
                    className="mr-10"
                  />
                  <svg
                    width={19}
                    height={19}
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.821428 2.625C0.821428 1.60938 1.64174 0.75 2.69643 0.75H6.44643C7.46205 0.75 8.32143 1.60938 8.32143 2.625V6.375C8.32143 7.42969 7.46205 8.25 6.44643 8.25H2.69643C1.64174 8.25 0.821428 7.42969 0.821428 6.375V2.625ZM2.69643 6.375H6.44643V2.625H2.69643V6.375ZM0.821428 12.625C0.821428 11.6094 1.64174 10.75 2.69643 10.75H6.44643C7.46205 10.75 8.32143 11.6094 8.32143 12.625V16.375C8.32143 17.4297 7.46205 18.25 6.44643 18.25H2.69643C1.64174 18.25 0.821428 17.4297 0.821428 16.375V12.625ZM2.69643 16.375H6.44643V12.625H2.69643V16.375ZM16.4464 0.75C17.4621 0.75 18.3214 1.60938 18.3214 2.625V6.375C18.3214 7.42969 17.4621 8.25 16.4464 8.25H12.6964C11.6417 8.25 10.8214 7.42969 10.8214 6.375V2.625C10.8214 1.60938 11.6417 0.75 12.6964 0.75H16.4464ZM16.4464 2.625H12.6964V6.375H16.4464V2.625ZM10.8214 12.625C10.8214 11.6094 11.6417 10.75 12.6964 10.75H16.4464C17.4621 10.75 18.3214 11.6094 18.3214 12.625V16.375C18.3214 17.4297 17.4621 18.25 16.4464 18.25H12.6964C11.6417 18.25 10.8214 17.4297 10.8214 16.375V12.625ZM12.6964 16.375H16.4464V12.625H12.6964V16.375Z"
                      fill="#0AA5C7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="row unselect select-multi">
            {SelectedImages.map((image, index) => (
              <div
                className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                style={{ paddingRight: 7 }}
              >
                <div className="tp-catagori-2__content-box mb-15">
                  <div className="tp-catagori-2__content plr text-center">
                    <img
                      className="w-32"
                      style={{ height: "170px" }}
                      key={index}
                      src={image}
                      // src="assets/img/blog/select-image-1.png"
                      alt=""
                    />
                    <span
                      className="dlt-icon"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeImage(index)}
                    >
                      <svg
                        width={15}
                        height={16}
                        viewBox="0 0 15 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.57143 12.5C5.57143 12.7812 5.32143 13 5.07143 13C4.79018 13 4.57143 12.7812 4.57143 12.5V6C4.57143 5.75 4.79018 5.5 5.07143 5.5C5.32143 5.5 5.57143 5.75 5.57143 6V12.5ZM8.07143 12.5C8.07143 12.7812 7.82143 13 7.57143 13C7.29018 13 7.07143 12.7812 7.07143 12.5V6C7.07143 5.75 7.29018 5.5 7.57143 5.5C7.82143 5.5 8.07143 5.75 8.07143 6V12.5ZM10.5714 12.5C10.5714 12.7812 10.3214 13 10.0714 13C9.79018 13 9.57143 12.7812 9.57143 12.5V6C9.57143 5.75 9.79018 5.5 10.0714 5.5C10.3214 5.5 10.5714 5.75 10.5714 6V12.5ZM10.4777 0.78125L11.6339 2.5H13.8214C14.2277 2.5 14.5714 2.84375 14.5714 3.25C14.5714 3.6875 14.2277 4 13.8214 4H13.5714V13.5C13.5714 14.9062 12.4464 16 11.0714 16H4.07143C2.66518 16 1.57143 14.9062 1.57143 13.5V4H1.32143C0.883928 4 0.571428 3.6875 0.571428 3.25C0.571428 2.84375 0.883928 2.5 1.32143 2.5H3.47768L4.63393 0.78125C4.94643 0.3125 5.50893 0 6.10268 0H9.00893C9.60268 0 10.1652 0.3125 10.4777 0.78125ZM5.29018 2.5H9.82143L9.22768 1.625C9.19643 1.5625 9.10268 1.5 9.00893 1.5H6.10268C6.00893 1.5 5.91518 1.5625 5.88393 1.625L5.29018 2.5ZM3.07143 13.5C3.07143 14.0625 3.50893 14.5 4.07143 14.5H11.0714C11.6027 14.5 12.0714 14.0625 12.0714 13.5V4H3.07143V13.5Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )} */}
    </>
  );
}
